import { render, staticRenderFns } from "./BrandCustom.vue?vue&type=template&id=1742867d&scoped=true"
import script from "./BrandCustom.vue?vue&type=script&lang=js"
export * from "./BrandCustom.vue?vue&type=script&lang=js"
import style0 from "./BrandCustom.vue?vue&type=style&index=0&id=1742867d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1742867d",
  null
  
)

export default component.exports